import InfoTanariumApiClient from "./InfoTanariumApiClient"

let Api = new InfoTanariumApiClient(window.localStorage.dev === "true" ? "http://localhost:81/api" : "/api")

export default Api